import { Injectable } from '@angular/core';
export var AlertConfig = (function () {
    function AlertConfig() {
        /** default alert type */
        this.type = 'warning';
        /** is alerts are dismissible by default */
        this.dismissible = false;
        /** default time before alert will dismiss */
        this.dismissOnTimeout = undefined;
    }
    AlertConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AlertConfig.ctorParameters = function () { return []; };
    return AlertConfig;
}());
//# sourceMappingURL=alert.config.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/alert/alert.config.js
// module id = ../../../../ng2-bootstrap/alert/alert.config.js
// module chunks = 4